const MAX_TEXT_LENGTH = {
  CHAPTER_TITLE: 124,
  DEDICATION: 1000,
  COVER_INPUT_IDEAS: 1000,
};

module.exports = MAX_TEXT_LENGTH;
